// // Preloader.js
// import React, { useEffect, useState } from "react";
// import Logo from "../assets/logo.png"; 
// import "../Styles/phoneinput.css"; // Custom SCSS file
// import { useLocation } from "react-router-dom";


// const Preloader = ({ duration = 1500 }) => {
//   const [loading, setLoading] = useState(true);
//   const location = useLocation();

//   useEffect(() => {
//     setLoading(true);
//     const timer = setTimeout(() => setLoading(false), duration);
//     return () => clearTimeout(timer);
//   }, [location, duration]); // run on every route change

//   if (!loading) return null;

//   return (
//     <div className="preloader">
//       <img src= {Logo} alt="PGS Logo" className="preloader-logo" />
//       {/* <img src="/logo.png" alt="Logo" className="preloader-logo" /> */}
//     </div>
//   );
// };

// export default Preloader;
import React, { useEffect, useState } from "react";
import Logo from "../assets/logo.png"; 
import "../Styles/phoneinput.css"; 
import { useLocation } from "react-router-dom";

const Preloader = ({ duration = 1500 }) => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), duration);
    return () => clearTimeout(timer);
  }, [location, duration]);

  if (!loading) return null;

  return (
    <div className="preloader">
      <img src={Logo} alt="PGS Logo" className="preloader-logo" />
      <h1 className="preloader-text">PARAMOUNT GREEN SERVICES</h1>
    </div>
  );
};

export default Preloader;
